export default __webpack_public_path__ + "static/media/beneficiary.0bf7fba3.webp";